import { render, staticRenderFns } from "./TwLcUpload.vue?vue&type=template&id=5199c76a&scoped=true&"
import script from "./TwLcUpload.vue?vue&type=script&lang=js&"
export * from "./TwLcUpload.vue?vue&type=script&lang=js&"
import style0 from "./TwLcUpload.vue?vue&type=style&index=0&id=5199c76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5199c76a",
  null
  
)

export default component.exports